import {Inject, Injectable} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Log} from "../interface/log";
import {LoginLog} from "../interface/login-log";
import {HttpClient} from "@angular/common/http";
import {first} from "rxjs/operators";
import {User} from "../interface/user";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class LoginLogService {
  private readonly loginLogListSubject: ReplaySubject<CountedAndPaginated<LoginLog>> = new ReplaySubject<CountedAndPaginated<LoginLog>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public getLoginLogListSubject(): ReplaySubject<CountedAndPaginated<LoginLog>> {
    return this.loginLogListSubject;
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/sso/api/login-log?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<LoginLog>) => {
        this.loginLogListSubject.next(result);
      });
  }
}
